import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard } from '@angular/material/card'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { QuoteRefusalReasonService } from '../../../core/services/purchases/quote-refusal-reason/quote-refusal-reason.service'

@Component({
  selector: 'modal-toggle-status-quote-refusal-reason',
  imports: [MatCard, MatDivider, MatProgressBar],
  templateUrl: './modal-toggle-status-quote-refusal-reason.component.html',
  styleUrl: './modal-toggle-status-quote-refusal-reason.component.scss',
  standalone: true,
})
export class ModalToggleStatusQuoteRefusalReasonComponent implements OnInit {
  constructor(
    private quoteRefusalReasonService: QuoteRefusalReasonService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalToggleStatusQuoteRefusalReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  @Output() responseCreate = new EventEmitter()
  item: any = {}
  loading = false

  ngOnInit(): void {
    this.toggleStatus()
  }

  close() {
    this.dialogRef.close()
  }

  toggleStatus() {
    this.loading = true
    this.quoteRefusalReasonService
      .toggleStatusQuoteRefusalReason(this.item.id)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit(true)
          this.close()
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          this.snackbar.errorRequest(err)
          this.close()
        },
        complete: () => {},
      })
  }
}
